import { AttendeePlayer } from "./IPlayer";

export interface IGameAttendances extends IAttendance {
  player: AttendeePlayer;
}

export interface IAttendance {
  assists_made: number;
  attended: boolean | null;
  created_at: string;
  game_id: number;
  goals_scored: number;
  id: number;
  player_id: number;
  points_earned: number;
  points_earned_breakdown: Array<{ total: number; type: string }> | null;
  team: string | null;
  rating: number;
}

export const defaultPointsBreakDown: Array<{ total: number; type: string }> = [
  { type: "assist", total: 0 },
  { type: "goals", total: 0 },
  { type: "mom", total: 0 },
  { type: "effort", total: 0 },
  { type: "attendance", total: 0 },
  { type: "defense", total: 0 },
  { type: "game_result", total: 0 },
  { type: "creativity", total: 0 },
  { type: "game_rating", total: 0 },
];

export const pointsTypeMapper: { [key: string]: string } = {
  assist: "Assist",
  goals: "Goals",
  mom: "Man of Match votes",
  effort: "Workhorse votes",
  attendance: "Attendance",
  defense: "Defender votes",
  game_result: "Game result",
  creativity: "Playmaker votes",
  game_rating: "Rating",
};

export enum DEFAULT_TEAMS {
  HOST = "HOST",
  VISITOR = "VISITOR",
}
